'use strict';
import {makeAbbreviate} from '../../core-utilities/filters/filterUtils';

module.exports = [
  makeAbbreviate];



// WEBPACK FOOTER //
// ./src/js/personnel/filters/name-initials.js